module.exports = __webpack_public_path__ + "static/media/oneHundred_326.e3bdcd64.png";